/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService, JsonApiResource} from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CrmServiceProviderResourceService extends AbstractResourceService<boolean,
  boolean,
  any,
  any> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('crmServiceProviderUrl'));
  }

  hasCurrentEmployeeSales(): Observable<JsonApiResource<boolean, any>> {
    return <Observable<JsonApiResource<boolean, any>>>this.httpClient?.get(`${this.url}/has-current`);
  }
}

